export default __webpack_public_path__ + "static/media/thumbs-up-circle.1da0a0be.png";